import React, { lazy, Suspense } from 'react'
import styled from 'styled-components'

import { Button, Spinner, Text } from 'components'

import withNavigationBar from 'hoc/nav-bar/with-navigation-bar'
import { colors } from 'utils/colors'
import { useTranslation } from 'react-i18next'
const SomethingWentWrong = lazy(() => import('assets/something-went-wrong.svg'))

class ErrorBoundary extends React.Component<{ hasToken: boolean }> {
  state = { hasError: false }

  constructor(props: { hasToken: boolean }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.hasToken ? (
        <ErrorFallBackWithNavBar isTokenPresent={this.props.hasToken} />
      ) : (
        <ErrorFallback isTokenPresent={this.props.hasToken} />
      )
    }

    return this.props.children
  }
}

const ErrorFallback: React.ComponentType<JSX.IntrinsicAttributes & { isTokenPresent: boolean }> = ({
  isTokenPresent,
}) => {
  const { t } = useTranslation()

  return (
    <Container isTokenPresent={isTokenPresent}>
      <Suspense fallback={<Spinner fontSize={80} />}>
        <SomethingWentWrong />
      </Suspense>
      <Title>
        <Orange>Uh oh!</Orange> {t('something_went_wrong_error')}
      </Title>
      <Text color="gray7" fontSize={20} textAlign="center">
        try_again_later_lbl
      </Text>

      <Anchor href={window.location.pathname}>
        <Button icon={['far', 'sync']} variant="outline" marginTop="16px">
          reload_page
        </Button>
      </Anchor>
    </Container>
  )
}

const ErrorFallBackWithNavBar = withNavigationBar(ErrorFallback)

export default ErrorBoundary

const Title = styled.div`
  ${(p) => p.theme.font({ family: 'montserrat', size: 34, weight: 'bold' })}
  padding-bottom: 10px;
  text-align: center;
`

const Orange = styled.span`
  color: ${(p) => p.theme.colors.orange};
`

const Container = styled.div<{ isTokenPresent: boolean }>`
  background-color: ${colors.gray2};
  height: ${(p) => (p.isTokenPresent ? 'calc(100vh - 60px)' : '100vh')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
`

const Anchor = styled.a`
  text-decoration: none;
  color: ${colors.blue1};
`
